export const STORAGE_PREFIX = '__klarna_sdk_';
export var EStorageTypes;
(function (EStorageTypes) {
    EStorageTypes["localStorage"] = "localStorage";
    EStorageTypes["sessionStorage"] = "sessionStorage";
    EStorageTypes["klarnaIframeStorage"] = "klarnaIframeStorage";
})(EStorageTypes || (EStorageTypes = {}));
